
// import React, { useContext, useEffect, useState } from 'react';
// import { useLocation, useNavigate } from 'react-router-dom';
// import {
//     Box, Button, Typography, IconButton, CircularProgress,
//     FormControlLabel, Checkbox,
//     Divider,
//     TextField,
//     Grid,
// } from '@mui/material';
// import Context from '../../context/Context';
// import axios from 'axios';
// import apiUrl from '../../Config';
// import { toast } from 'react-toastify';

// const token = localStorage.getItem("token");

// const RolePermissions = () => {
//     const { permissions, getPermissions } = useContext(Context);
//     const location = useLocation();
//     const navigate = useNavigate();
//     const role = location?.state?.role || '';

//     const [selectedPermissions, setSelectedPermissions] = useState([]);
//     const [loading, setLoading] = useState(false);
//     const [error, setError] = useState(null);


//     const getRolePermission = async () => {

//         try {
//             // const response = await axios.get(apiUrl + `/rolepermission/getrolepermissions/${role.id}`)
//             const response = await axios.get(
//   apiUrl + `/rolepermission/getrolepermissions/${role.id}`,
//   {
//     headers: {
//       Authorization: `Bearer ${token}`,
//     },
//   }
// );
//             if (response?.data?.status === true) {
//                 const permissionIds = response.data.data.map(item => item.permissionId);
//                 setSelectedPermissions(permissionIds);
//             }

//         } catch (error) {
//             setError(error?.response?.data?.message || 'Error for geting roles')
//         }

//     }

//     const handleCheckboxChange = async (id) => {
//         if (selectedPermissions.includes(id)) {
//             // Permission is being unchecked
//             try {
//                 const response = await removePermissionFromRole(id);
//                 setSelectedPermissions((prev) =>
//                     prev.filter((permId) => permId !== id)
//                 );
//                 if (response?.data?.status === true) {
//                     toast.success(response?.data?.message || 'Permission removed');
//                 }

//             } catch (error) {
//                 setError(error?.response?.data?.message || 'Error removing permission');
//             }
//         } else {
//             // Permission is being checked
//             setSelectedPermissions((prev) => [...prev, id]);
//         }
//     };

//     const removePermissionFromRole = async (permissionId) => {
//         try {
//             const response = await axios.delete(`${apiUrl}/rolepermission/deleterolepermission`, {
//                 headers: {
//                     'Content-Type': 'application/json',
//                      Authorization: `Bearer ${token}`
//                 },
//                 data: {
//                     roleId: role.id,
//                     permissionId: permissionId
//                 }
//             });
//             return response;
//         } catch (error) {
//             console.error("Failed to remove permission:", error);
//             throw error;
//         }
//     };

//     const handleSubmit = async (e) => {
//         e.preventDefault();
//         setError(null);

//         if (!role?.id) {
//             toast.error('Role ID is missing.');
//             return;
//         }

//         if (selectedPermissions.length === 0) {
//             setError('Please select at least one permission.');
//             return;
//         }

//         const payload = {
//             roleId: role.id,
//             permissionId: selectedPermissions,
//         };

//         try {
//             setLoading(true);
//             // const response = await axios.post(`${apiUrl}/rolepermission/rolepermission`, payload);
//             const response = await axios.post(
//   `${apiUrl}/rolepermission/rolepermission`,
//   payload,
//   {
//     headers: {
//       Authorization: `Bearer ${token}`,
//     },
//   }
// );

//             if (response?.data?.status === true) {
//                 toast.success(response?.data?.message || 'Permissions updated successfully');
//                 navigate(-1); // go back
//             } 
//         } catch (err) {
//             setError(err?.response?.data?.message || 'Error assigning role permissions');
//         } finally {
//             setLoading(false);
//         }
//     };

//     useEffect(() => {
//         getPermissions();
//         getRolePermission()
//     }, []);

//     return (
//         <Box sx={{ backgroundColor: "", padding: 3 }}>
//             <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
//                 <Typography variant="h3">Role Permissions</Typography>
//             </Box>
//             <Divider sx={{ mb: 3 }} />

//             <TextField
//                 label="Role Name"
//                 size="small"
//                 value={role.name || ''}
//                 fullWidth
//                 InputProps={{ readOnly: true }}
//                 sx={{ mb: 3 }}
//             />
//   <Grid item xs={12} sm={12}>
//   <Box
//     sx={{
//       display: "flex",
//       flexDirection: "row",
//       justifyContent: "space-between",
//       alignItems: "center",
//       mt: 1,
//     }}
//   >
//     <FormControlLabel
//       control={
//         <Checkbox
//           name="option1"
//         //   checked={formData.option1}
//           onChange={handleCheckboxChange}
//           size="small"
//         />
//       }
//       label="canView"
//     />

//     <FormControlLabel
//       control={
//         <Checkbox
//           name="option2"
//         //   checked={formData.option2}
//           onChange={handleCheckboxChange}
//           size="small"
//         />
//       }
//       label="canCreate"
//     />

//     <FormControlLabel
//       control={
//         <Checkbox
//           name="option3"
//         //   checked={formData.option3}
//           onChange={handleCheckboxChange}
//           size="small"
//         />
//       }
//       label="canEdit"
//     />

//     <FormControlLabel
//       control={
//         <Checkbox
//           name="option4"
//         //   checked={formData.option4}
//           onChange={handleCheckboxChange}
//           size="small"
//         />
//       }
//       label="canDelete"
//     />
//   </Box>
// </Grid>
//             <Typography variant="h6" sx={{ mb: 2 }}>Select Permissions</Typography>

//             {permissions.length === 0 ? (
//                 <CircularProgress />
//             ) : (
//                 <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 2 }}>
//                     {permissions.map((perm) => (
//                         <FormControlLabel
//                             key={perm.id}
//                             control={
//                                 <Checkbox
//                                     checked={selectedPermissions.includes(perm.id)}
//                                     onChange={() => handleCheckboxChange(perm.id)}
//                                 />
//                             }
//                             label={perm.name}
//                         />
//                     ))}
//                 </Box>
//             )}

//             {error && (
//                 <Typography color="error" sx={{ mt: 2 }}>
//                     {error}
//                 </Typography>
//             )}

//             <Box display="flex" justifyContent="end" mt={3} gap={2}>
//                 <Button variant="outlined" color="primary" onClick={() => navigate(-1)}>
//                     Cancel
//                 </Button>
//                 <Button
//                     type="submit"
//                     variant="contained"
//                     color="primary"
//                     disabled={loading}
//                     onClick={handleSubmit}
//                 >
//                     {loading ? (
//                         <CircularProgress size={24} sx={{ color: '#fff' }} />
//                     ) : (
//                         role ? 'Update' : 'Create'
//                     )}
//                 </Button>
//             </Box>
//         </Box>
//     );
// };

// export default RolePermissions;


import React, { useContext, useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import {
  Box,
  Button,
  Typography,
  CircularProgress,
  FormControlLabel,
  Checkbox,
  Divider,
  TextField
} from '@mui/material';
import Context from '../../context/Context';
import { toast } from 'react-toastify';
import apiClient from '../../utils/apiClient';

const RolePermissions = () => {
  const { permissions, getPermissions } = useContext(Context);
  const location = useLocation();
  const navigate = useNavigate();
  const role = location?.state?.role || '';

  // ✅ Updated state (IMPORTANT)
  const [selectedPermissions, setSelectedPermissions] = useState({});
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  // ✅ Fetch existing role permissions (EDIT MODE SUPPORT)
  const getRolePermission = async () => {
    try {
      const response = await apiClient.get(`/rolepermission/getrolepermissions/${role.id}`);

      if (response?.data?.status === true) {
        const formatted = {};

        response.data.data.forEach(item => {
          formatted[item.permissionId] = {
            permissionId: item.permissionId,
            canView: item.canView || false,
            canEdit: item.canEdit || false,
            canCreate: item.canCreate || false,
            canDelete: item.canDelete || false
          };
        });

        setSelectedPermissions(formatted);
      }

    } catch (error) {
      setError(error?.response?.data?.message || 'Error getting role permissions');
    }
  };

  // ✅ Select / unselect permission
  const handlePermissionSelect = (permissionId) => {
    setSelectedPermissions(prev => {
      const updated = { ...prev };

      if (updated[permissionId]) {
        delete updated[permissionId];
      } else {
        updated[permissionId] = {
          permissionId,
          canView: false,
          canEdit: false,
          canCreate: false,
          canDelete: false
        };
      }

      return updated;
    });
  };

  // ✅ Toggle flags
  const handleFlagChange = (permissionId, field) => {
    setSelectedPermissions(prev => ({
      ...prev,
      [permissionId]: {
        ...prev[permissionId],
        [field]: !prev[permissionId]?.[field]
      }
    }));
  };

  // ✅ Submit
  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);

    if (!role?.id) {
      toast.error('Role ID is missing.');
      return;
    }

    if (Object.keys(selectedPermissions).length === 0) {
      setError('Please select at least one permission.');
      return;
    }

    const payload = {
      roleId: role.id,
      permissionIds: Object.values(selectedPermissions)
    };

    try {
      setLoading(true);

      const response = await apiClient.post('/rolepermission/rolepermission', payload);

      if (response?.data?.status === true) {
        toast.success(response?.data?.message || 'Permissions updated successfully');
        navigate(-1);
      }

    } catch (err) {
      setError(err?.response?.data?.message || 'Error assigning role permissions');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getPermissions();
    getRolePermission();
  }, []);

  return (
    <Box sx={{ padding: 3 }}>
      
      <Typography variant="h4" sx={{ mb: 2 }}>
        Role Permissions
      </Typography>

      <Divider sx={{ mb: 3 }} />

      {/* Role Name */}
      <TextField
        label="Role Name"
        size="small"
        value={role.name || ''}
        fullWidth
        InputProps={{ readOnly: true }}
        sx={{ mb: 3 }}
      />

      <Typography variant="h6" sx={{ mb: 2 }}>
        Select Permissions
      </Typography>

      {permissions.length === 0 ? (
        <CircularProgress />
      ) : (
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
          {permissions.map((perm) => {
            const isSelected = !!selectedPermissions[perm.id];
            const flags = selectedPermissions[perm.id] || {};

            return (
              <Box
                key={perm.id}
                sx={{
                  border: "1px solid #ddd",
                  p: 2,
                  borderRadius: 2
                }}
              >
                {/* Permission checkbox */}
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={isSelected}
                      onChange={() => handlePermissionSelect(perm.id)}
                    />
                  }
                  label={perm.name}
                />

                {/* Flags */}
                {isSelected && (
                  <Box sx={{ display: "flex", gap: 3, ml: 3, flexWrap: "wrap" }}>
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={flags.canView || false}
                          onChange={() => handleFlagChange(perm.id, "canView")}
                        />
                      }
                      label="View"
                    />

                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={flags.canCreate || false}
                          onChange={() => handleFlagChange(perm.id, "canCreate")}
                        />
                      }
                      label="Create"
                    />

                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={flags.canEdit || false}
                          onChange={() => handleFlagChange(perm.id, "canEdit")}
                        />
                      }
                      label="Edit"
                    />

                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={flags.canDelete || false}
                          onChange={() => handleFlagChange(perm.id, "canDelete")}
                        />
                      }
                      label="Delete"
                    />
                  </Box>
                )}
              </Box>
            );
          })}
        </Box>
      )}

      {/* Error */}
      {error && (
        <Typography color="error" sx={{ mt: 2 }}>
          {error}
        </Typography>
      )}

      {/* Actions */}
      <Box display="flex" justifyContent="end" mt={3} gap={2}>
        <Button variant="outlined" onClick={() => navigate(-1)}>
          Cancel
        </Button>

        <Button
          variant="contained"
          onClick={handleSubmit}
          disabled={loading}
        >
          {loading ? <CircularProgress size={24} sx={{ color: '#fff' }} /> : 'Update'}
        </Button>
      </Box>
    </Box>
  );
};

export default RolePermissions;
